import script from "./Analitics.vue?vue&type=script&lang=ts&setup=true"
export * from "./Analitics.vue?vue&type=script&lang=ts&setup=true"

import "./Analitics.vue?vue&type=style&index=0&id=4d512414&lang=sass"

const __exports__ = script;

export default __exports__